import { ODForms } from '@/model';
import { Nullable } from '@homeserve/od-typings/utils';
import { Validator } from 'vee-validate';
import { Emit, Inject, Model, Vue } from 'vue-property-decorator';

export abstract class BaseStepForm<T extends ODForms> extends Vue {
  public abstract readonly formScope: string;

  @Inject('$validator')
  public readonly $validator!: Validator;

  @Model('change', { type: Object })
  public readonly model!: T;

  @Emit('change')
  public resetFieldValue(field: keyof T, value: Nullable<string>): T {
    return {
      ...this.model,
      [field]: value,
    };
  }

  public async isValid(): Promise<boolean> {
    return this.$validator.validateAll(this.formScope);
  }
}
